import { PropsWithChildren } from 'react';
import { Tooltip } from '../../Tooltip';
import { styled } from '@mui/material/styles';

const CellWrapper = styled('span')({
  display: 'inline-block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%'
});

const TooltipWrapper = styled('div')({
  fontSize: '12px',
  lineHeight: '1.1',
  whiteSpace: 'pre-line'
});

export const CellWithError = (props: PropsWithChildren<{ error?: string; tooltip?: JSX.Element | string }>) => {
  const { children, error, tooltip } = props;
  if (error) {
    return (
      <Tooltip title={<TooltipWrapper>{error}</TooltipWrapper>}>
        <CellWrapper>{error}</CellWrapper>
      </Tooltip>
    );
  }
  if (tooltip) {
    return (
      <Tooltip title={<TooltipWrapper>{tooltip}</TooltipWrapper>}>
        <CellWrapper>{children}</CellWrapper>
      </Tooltip>
    );
  }
  return <CellWrapper>{children}</CellWrapper>;
};
